























































































































import { Vue, Component } from "vue-property-decorator";
import Prism from "vue-prism-component";
import { required, url } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { WebhookItem } from "@/modules/webhooks/types";
import { webhooks } from "@/modules/webhooks/utils";

const Webhooks = namespace("webhooks");
@Component({
  components: {
    prism: Prism,
  },
})
export default class EditWebhook extends Vue {
  @Webhooks.Action("updateWebhook") updateWebhook!: (
    payload?: WebhookItem
  ) => Promise<{}>;
  @Webhooks.Action("fetchCurrentWebhook") fetchCurrentWebhook!: (
    webhookId?: string
  ) => Promise<{}>;
  @Webhooks.Action("fetchWebhooks") fetchWebhooks!: () => Promise<{}>;
  @Webhooks.Getter("getCurrentWebhook") currentWebhook: WebhookItem;

  selectedWebhook = webhooks[0];
  hooks = webhooks;

  code() {
    return `
{
    event: ${this.removeSpaces(this.selectedWebhook.label)},
    secret:"secrettt",
    applicantId:"08d8cd73-df3c-413d-8505-4a9fcb7cb2b2",
    status:"processed"
}
    `;
  }

  webhookForm = {
    name: "",
    url: "",
    endpoint: "",
    description: "",
  };

  loading = false;
  hasErrors = false;
  isProcessedHookSelected = true;
  isReviewedHookSelected = false;

  async beforeMount() {
    const { webhookId } = this.$route.params;
    await this.fetchCurrentWebhook(webhookId);

    // Set Webhook event
    const matchedWebhook = this.hooks.find(
      (hook) => this.removeSpaces(hook.label) === this.currentWebhook.event
    );
    if (matchedWebhook) {
      this.selectedWebhook = matchedWebhook;
    }

    this.webhookForm.name = this.currentWebhook.name;
    this.webhookForm.endpoint = this.currentWebhook.url;
    this.webhookForm.description = this.currentWebhook.description || '';
    
  }

  removeSpaces = (string) => string.replace(/\s/g, "");

  goBack() {
    const { webhookId } = this.$route.params;
    this.$router.push({ name: "viewWebhook", params: { webhookId } });
  }

  submitWebhook() {
    this.loading = true;
    //We only need the rest of the webhook
    //eslint-disable-next-line
    
    const { name, url, description, ...restOfWebhook } = this.currentWebhook;

    

    this.updateWebhook({
      name: this.webhookForm.name,
      url: this.webhookForm.endpoint,
      description: this.webhookForm.description,
      ...restOfWebhook,
    })
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Webhook updated successfully.",
        });
        this.fetchWebhooks();
        this.goBack();
      })
      .catch(() => {
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to update webhook.",
        });
        this.loading = false;
      });
  }
  validations() {
    return {
      webhookForm: {
        endpoint: {
          required,
          url,
        },
        name: {
          required,
        },
        description: {
          required,
        },
      },
    };
  }
}
